import React from 'react'

/*
Usage:
<TabGroup siblings={} default="" render={tab => ( [
    <Tab TabGroup={tab} key={0} title="" onClick={}/>,
    <Tab TabGroup={tab} key={1} title="" onClick={}/>,
    ...
]
)} />

Variables:
int siblings    - Amount of render props for styling
str default     - title of default render prop selection
int key         - Just place consecutive numbers to avoid errors
str title       - title of button, text to be displayed
func onClick    - Event function to bind to button click
*/

export class TabGroup extends React.Component {
    constructor(props) {
        super(props);
        this.mobileTarget = window.matchMedia("(min-width: 700px)") /* Retain 
        the target so the event listener can be unmounted */
        this.hideTasksListener = event => { // Define the event lister
            if (event.matches) { // Window has gone from desktop to mobile view
                this.setState({
                    mobileView: true,
                })
            } else { // mobile to desktop
                this.setState({
                    mobileView: false,
                })
            }
        }
        this.mobileTarget.addEventListener("change", this.hideTasksListener)
        this.state = {
            indexActive: 0,
            mobileView: this.mobileTarget.matches,
        }
    }

    componentWillUnmount() {
        this.mobileTarget.removeEventListener("change", this.hideTasksListener)
    }

    setSelected(index) {
        this.setState({indexActive: index}, () => {
            this.props.noteActiveTab && this.props.noteActiveTab(index)
        })
    }

    isTabActive(index) {
        if (this.state.indexActive === index) {
            return true
        } else {
            return false
        }
    }

    render() {
        const childrenAsArray = React.Children.count(this.props.children) === 1 ? 
            [this.props.children] : this.props.children
        const override = this.props.indexOverride
        const indexActive = Boolean(override) ? override : this.state.indexActive
        const isTabActive = (index) => {
            return(indexActive == index)
        }
        const realTabs = React.Children.map(this.props.children, (child, index) => {
                if (child) {
                    return (
                        React.cloneElement(child, {
                                selected: isTabActive(index),
                                onTabClick: () => { this.setSelected(index) },
                                key: `tab-label-${index}`
                            }, []) // No children
                    )
                }
            })

        const numChildren = childrenAsArray.filter(child => typeof child === 'object').length
        let template = ''

        const fracChildren = 1 / numChildren;
        for (let i = 0; i < numChildren; i += 1) {
            template += ` ${fracChildren}fr`
        }
        return (
            <div>
                {React.Children.count(this.props.children) > 1 && (
                    <div class="ps-flex-tab" style={{gridTemplateColumns: template}}>
                        {realTabs}
                    </div>
                )}
                <br />
                {
                    childrenAsArray[indexActive].props.children
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/helpers/Tabs/TabGroup.jsx